__turbopack_context__.v({
  "expansion": "Expansion-module-scss-module__yvy36W__expansion",
  "expansion_show": "Expansion-module-scss-module__yvy36W__expansion_show",
  "section": "Expansion-module-scss-module__yvy36W__section",
  "section_links": "Expansion-module-scss-module__yvy36W__section_links",
  "section_name": "Expansion-module-scss-module__yvy36W__section_name",
});
